import { isEqual } from 'lodash';

export const generateDecimalRegexp = (
  decimalPlaces: number,
  isPositiveNumber: boolean = true,
  additionalOptions: {
    allowZero?: boolean;
  } = {
    allowZero: false,
  },
): RegExp => {
  const { allowZero } = additionalOptions;

  const regExpStr: string = `${
    isPositiveNumber ? '' : '^-?('
  }([1-9]\\d*\\.?\\d{0,${decimalPlaces}})|(0(\\.\\d{0,${decimalPlaces}})?)${isPositiveNumber ? '' : ')?'}`;

  const integerRegExpStr: string = isPositiveNumber
    ? '^([1-9]\\d*)'
    : '^(-?([1-9]\\d*))';

  const isWholeNumber = isEqual(decimalPlaces, 0);

  // Allow zero for positive whole numbers by using a non-capturing group to match either positive integers or just zero
  if (isPositiveNumber && isWholeNumber && allowZero) {
    return new RegExp('^(?:[1-9]\\d*|0)', 'gi');
  }

  return new RegExp(isWholeNumber ? integerRegExpStr : regExpStr, 'gi');
};

const POSITIVE_NUMBER_REGEX: RegExp = generateDecimalRegexp(2);
const POSITIVE_NEGATIVE_NUMBER_REGEX: RegExp = generateDecimalRegexp(2, false);
const MAX_SIX_POSITIVE_NUMBER_REGEX: RegExp = generateDecimalRegexp(6);
const MAX_SIX_NEGATIVE_POSITIVE_NUMBER_REGEX: RegExp = generateDecimalRegexp(
  6,
  false,
);

export {
  POSITIVE_NUMBER_REGEX,
  POSITIVE_NEGATIVE_NUMBER_REGEX,
  MAX_SIX_POSITIVE_NUMBER_REGEX,
  MAX_SIX_NEGATIVE_POSITIVE_NUMBER_REGEX,
};
